import * as React from "react"

import { cn } from "../../lib/utils"

// 26BET design-kit Tag: a pill filter chip with a selected/gold-outline
// state — see checklist item "Tag: single component for filter chips (day
// filters, sport chips) with a selected/gold-outline state".
function Tag({
  selected = false,
  className,
  ...props
}: React.ComponentProps<"button"> & { selected?: boolean }) {
  return (
    <button
      type="button"
      data-slot="tag"
      aria-pressed={selected}
      className={cn(
        "inline-flex h-[30px] shrink-0 items-center gap-1.5 !rounded-full !border px-3 text-sm font-medium whitespace-nowrap transition-colors",
        selected
          ? "!border-[var(--gold-500)] !bg-[var(--gold-a20)] !text-[var(--gold-400)]"
          : "!border-[var(--border-subtle)] !bg-[var(--surface-2)] !text-[var(--text-secondary)] hover:!border-[var(--border-default)] hover:!bg-[var(--surface-3)] hover:!text-[var(--text-primary)]",
        className
      )}
      {...props}
    />
  )
}

export { Tag }
